import React from 'react'
import moment from 'moment';

const PaymentWarning = ({ user, type }) => {
    if ((user.paymentStatus !== 'warning' && user.paymentStatus !== 'debt' ) || user.paymentStatus === undefined ) {
        return null
    }
    if (type === 'top' && user.paymentStatus === 'warning'  ) {
        return (
            <div className="bg-white rounded shadow px-4 py-3 mb-3">
                <p className="mb-0"><div className="text-danger"><b>Akun Anda berpotensi untuk dibekukan.</b></div> Mohon lakukan pembayaran sebelum tanggal
                    <b> {moment(user.paymentDueDate).format("DD MMMM YYYY")}</b> dan konfirmasi ke email <b><a href="mailto: info@biteship.com">info@biteship.com</a></b>
                </p>
            </div>
        )
    } else if (type === 'top' && user.paymentStatus === 'debt'  ) {
        return (
            <div className="bg-white rounded shadow px-4 py-3 mb-3">
                <p className="mb-0"><div className="text-danger"><b>Akun Anda telah dibekukan.</b></div> Mohon lakukan pembayaran dan konfirmasi ke email <b><a href="mailto: info@biteship.com">info@biteship.com</a></b>
                </p>
            </div>
        )
    } else if (type === 'content') {
        return (
            <div className="bg-white rounded shadow px-4 py-3 mb-3 text-center">
                <br/>
                <br/>
                <h4>Maaf..</h4>
                <p className="mb-0">Akun Anda dibekukan. Mohon lakukan pembayaran dan konfirmasi ke email <b><a href="mailto: info@biteship.com">info@biteship.com </a></b>
                    agar tetap bisa melakukan order via Biteship.</p>
                <br/>
                <br/>
            </div>
        )
    }
};

export default PaymentWarning;
